/* eslint-disable */
import React, {Component} from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import Loader from 'react-loader';
import _ from 'lodash';

import SelectField from '../shared/SelectField';
import { transformFaculties, transformYears, transformCathedras }from "../../utils/const"

const selector = formValueSelector('groupFilter');

class GroupFilter extends Component {
  constructor(props) {
    super(props);
    this.renderListItem = this.renderListItem.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(this.props.myValues, true) && !_.isEqual(nextProps.myValues, this.props.myValues) ) {
      this.props.groupList(nextProps.myValues);
    }

  }

  renderListItem(group, i) {
    return (
      <div
        className="modal-react"
        key={group.gid}
        tabIndex={i}
        onClick={this.props.toggleModal(group.gid)}
        role="button">
        {group.name}
      </div>
    )
  }

  render() {
    const { isLoading, list, yearList, facultyList, cathedraList, groupList, myValues} = this.props;
    const faculties = transformFaculties(facultyList);
    const years = transformYears(yearList);
    const cathedras = transformCathedras(cathedraList);
    return (
      <div className="group__filter GF-selectWrapper">
        <SelectField className="GF-selectField" name="year" label="Год" options={years} onChange={() => {groupList(myValues)}}/>
        <SelectField className="GF-selectField" name="faculty" label="Факультет" options={faculties} onChange={() => groupList(myValues)}/>
        <SelectField className="GF-selectField" name="cathedra" label="Кафедра" options={cathedras}  onChange={() => groupList(myValues)}/>
        <Loader
          color="#7b2b2a"
          loaded={!isLoading}
        >
          {list.map(this.renderListItem)}
        </Loader>
      </div>
    )
  }
}

const groupFilterForm = reduxForm({
  form: 'groupFilter',
  enableReinitialize: true,
})(GroupFilter);


export default connect(
  state => ({
    myValues: selector(state, 'year', 'faculty', 'cathedra')
  })
)(groupFilterForm)